var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagePlaneBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_2431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5968 15.9133L0.890229 8.79624C0.751867 8.72434 0.635058 8.61143 0.553293 8.47054C0.471528 8.32965 0.428141 8.16652 0.428141 8C0.428141 7.83348 0.471528 7.67035 0.553293 7.52946C0.635058 7.38857 0.751867 7.27566 0.890229 7.20376L14.5968 0.0867205C14.7374 0.0135765 14.8944 -0.014164 15.0491 0.00680351C15.2038 0.027771 15.3496 0.0965624 15.4693 0.204985C15.589 0.313407 15.6775 0.45689 15.7241 0.618344C15.7708 0.779799 15.7738 0.952421 15.7327 1.11565L14.3614 6.57313C14.3446 6.64002 14.31 6.70006 14.262 6.74577C14.214 6.79148 14.1547 6.82084 14.0914 6.83019L7.4495 7.80968C7.4218 7.8139 7.39558 7.8258 7.37336 7.84423C7.35114 7.86266 7.33367 7.887 7.32264 7.9149L7.31093 7.95939C7.3058 7.99882 7.3131 8.03897 7.33164 8.07333C7.35018 8.10769 7.37888 8.13423 7.41307 8.14865L7.44885 8.15925L14.0842 9.13803C14.1474 9.14751 14.2066 9.17693 14.2545 9.22263C14.3023 9.26833 14.3368 9.3283 14.3535 9.39509L15.7327 14.8844C15.7738 15.0476 15.7708 15.2202 15.7241 15.3817C15.6775 15.5431 15.589 15.6866 15.4693 15.795C15.3496 15.9034 15.2038 15.9722 15.0491 15.9932C14.8944 16.0142 14.7374 15.9864 14.5968 15.9133Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_2431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagePlaneBlack);
export default __webpack_public_path__ + "static/media/message-plane-black.5a46717d0209db7c9fa6701c7bc5cccd.svg";
export { ForwardRef as ReactComponent };